import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

import {searchOutOfGymPlayers} from "../../../modules/player.js";
import OutOfGymPlayerCard from "../../components/out-of-gym-player-card/out-of-gym-player-card.js";


import buttonConfig from "./button-config.js";
import PlayScreenCard from "../play-screen/new-play-screen-card.js";

import NewsFeed from "../play-screen/news-feed/news-feed.js";

import OnlineRoomList from "../online-room-list/online-room-list.js";

import TournamentDialog from "../tournaments/tournament-dialog.js";
import TournamentBanner from "../tournaments/tournament-banner.js";

import {getActiveTournament} from "../../../modules/tournament.js";

import WelcomePopup from "../welcome-popup/welcome-popup.js";

import "./care-partner-dashboard.css";

class CarePartnerDashboard extends Component {
    constructor(props) {
        super(props);


        const POPUP_VERSION = 8;
        let popupVersion = parseInt(localStorage.getItem("welcome_popup1"), 10);

        //TO ENABLE THE POPUP - change to true!
        let showPopup = false;
        if (popupVersion === POPUP_VERSION) {
            showPopup = false;
        }


        if (showPopup) {
            localStorage.setItem("welcome_popup1", POPUP_VERSION);
        }

        this.state = {
            searching: false,
            page: 0,
            query: "",
            players: [],
            afterNewSearch: false,
            showEmptyQueryMessage: false, 
            startingSession: false,
            showTable: false,
            tournament_data: false,
            show_tournament_dialog: false,
            show_popup: showPopup
        };
    }

    async componentDidMount() {
        let {token} = this.props;
        let currentTournamentResponse = await getActiveTournament(token);

        if (currentTournamentResponse.data.success) {
            let tournamentData = currentTournamentResponse.data.tournament;
            let active = currentTournamentResponse.data.active;

            tournamentData.active = active;
            this.setState({
                tournament_data: tournamentData
            });
        }
    }
    
    handleChange(event) {        
        this.setState({query: event.target.value, showEmptyQueryMessage: false});
    }

    startPlayerSession() {
        this.setState({startingPlayerSession: true});
    }

    hidePopup() {
        this.setState({show_popup: false});
    }


    handleKeyPress(event) {
        if(event.key === 'Enter'){
            this.submitSearch(true);
        }
    }

    addNewPlayers(newPlayers) {
        const {players} = this.state;
        let newPlayerList = players;
        let found;
        for (let index in newPlayers) {
            found = false;
            let newPlayer = newPlayers[index];
            for (let playerIndex in players) {
                let currentPlayer = players[playerIndex];

                if (newPlayer.id === currentPlayer.id) {
                    found = true;
                    break;
                }
            }

            if (!found) {
                newPlayerList.push(newPlayer);
            }
        }

        this.setState({players: newPlayerList});
    }

    closeTable() {
        this.setState({showTable: false});
    }

    showTournamentDialog() {
        this.setState({show_tournament_dialog: true});
    }

    hideTournamentDialog() {
        this.setState({show_tournament_dialog: false});
    }

    async submitSearch(isNewSearch) {
        const {token} = this.props;
        const {searching, page, query} = this.state;
        
        if (query === "") {
            this.setState({showEmptyQueryMessage: true});
            return;
        }

        this.setState({showEmptyQueryMessage: false});

        if (searching) {
            return;
        }

        this.setState({searching: true, afterNewSearch: false});

        if (isNewSearch) {
            this.setState({players: []});
        }

        let response = await searchOutOfGymPlayers(query, page, token);
                 
        if (response.data.success) {
            let newPlayers = response.data.players
            this.addNewPlayers(newPlayers);
        }


        if (isNewSearch) {
            this.setState({afterNewSearch: true});
        }

        this.setState({searching: false, showTable: true});
    }

    render() {
        const {token} = this.props;
        const {query, players, searching, afterNewSearch, showEmptyQueryMessage, startingPlayerSession, showTable, tournament_data, show_tournament_dialog, show_popup} = this.state;

        let that = this;
        return (
            <div id='care_partner_dashboard_content'>
                {tournament_data && <TournamentDialog tournament_data={tournament_data} show={show_tournament_dialog} hide_func={this.hideTournamentDialog.bind(this)} token={token}/>}
                {tournament_data && <TournamentBanner tournament_data={tournament_data} show_func={this.showTournamentDialog.bind(this)}/>}
                <OnlineRoomList token={token}/>
                <WelcomePopup show={show_popup}  hide_func={this.hidePopup.bind(this)}/>
                <div id='care_partner_dashboard_container'>
                    <div id='care_partner_dashboard'>
                        <div>
                            
                            <div id='care_partner_user_search_instructions'>Search for a player to begin a session:</div>
                            <input id='care_partner_user_search' value={query} type='text' onChange={this.handleChange.bind(this)} onKeyPress={this.handleKeyPress.bind(this)} placeholder="insert a player's name"></input>
                            <button id='care_partner_search_submit' onClick={this.submitSearch.bind(this)}><i className='fa fa-search'></i></button>
                        </div>
                        {!searching && afterNewSearch && players.length === 0 && <div id='care_partner_search_no_players_found'>No player found.</div>}
                        {showEmptyQueryMessage && <div id='care_partner_search_no_players_empty_query_message'>Search cannot be empty</div>}
                        { (players.length > 0 && showTable) && 
                        <div id='care_partner_search_results'>   
                            <div id='care_partner_search_content'>                        
                                <table id='care_partner_search_results_table'>
                                    <tr>
                                        <th>Name</th><th>Assigning Therapist</th><th></th>
                                    </tr>
                                    {
                                        players.map(function(player) {
                                            return <OutOfGymPlayerCard player={player} token={token} startingPlayerSession={startingPlayerSession} startPlayerSession={that.startPlayerSession.bind(that)}></OutOfGymPlayerCard>
                                        })
                                    }
                                </table>
                                <div id='care_partner_results_close_button' onClick={this.closeTable.bind(this)}><i className='fa fa-times'></i></div>
                            </div>
                        </div>
                        }
                        {searching && <div id='care_partner_search_results_loader'>Searching... <i className='fa fa-spinner fa-spin'></i></div>}                

                        <div className='care-partner-play-buttons'>
                            <div id='care_partner_play_buttons_title'>Play without assigned session:</div>
                            {buttonConfig.map((cardData) => {
                                return <PlayScreenCard card_data={cardData} token={token}></PlayScreenCard>
                            })}
                        </div>

                        
                    </div>
                    <NewsFeed token={token}/>
                </div>
            </div>
           
        );
        
    }
}

const withState = connect(state => {
    const {player, player_game_session, player_game_session_activity, result, skill, user} = state;
    

    return {
        players: player.players,
        owned_players: player.owned_players,
        retrieved_assigned_players: player.retrieved_assigned_players,
        retrieved_players: player.retrieved_players,
        assigned_players: player.assigned_players,
        skills: skill.skills,
        results: result.results,
        token: user.token,
        currentUser: user,
        currentUserId: user.currentUserId,
        currentUserFirstName: user.currentUserFirstName,
        playerGameSessions: player_game_session.player_game_sessions,
        playerGameSessionActivities: player_game_session_activity.player_game_session_activities
    };
});
export default withRouter(withState(CarePartnerDashboard));


// WEBPACK FOOTER //
// ./src/components/containers/care-partner-dashboard/care-partner-dashboard.js